import { platform } from "@playroomkit/pr-common";
import { utils } from "@playroomkit/pr-wars/utils";
import { ForwardedRef, forwardRef } from "react";

const MainMenuBackground = forwardRef<HTMLVideoElement | HTMLImageElement, { source: string; placeholder: string, mobileBg?: string }>((props, ref) => {
  const { source, placeholder, mobileBg } = props;
  
  if (utils.isRunningInMobile() && platform.isRunningInDiscord) {
    return <img className="w-full h-full object-cover" ref={ref as ForwardedRef<HTMLImageElement>} src={placeholder} alt="bg-image" />
  }
  else if(!platform.isRunningInDiscord && utils.isRunningInMobile()){
    return (<img className={`w-full md:w-[350px] h-full object-cover position-center `} ref={ref as ForwardedRef<HTMLImageElement>} src={mobileBg} alt="bg-image" />)
  }

  return (
    <div>
    <video ref={ref as ForwardedRef<HTMLVideoElement>} autoPlay loop muted playsInline className="background-video" poster={placeholder}>
      <source src={source} type="video/webm" />
      Your browser does not support the video tag.
    </video>
  </div>
  );
});

export default MainMenuBackground;
